import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./App.css";

function MemberPortal() {
  const navigate = useNavigate();





  const [member, setMember] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
const chatEndRef = useRef(null);
const [showChat, setShowChat] = useState(false);
  const [unread, setUnread] = useState(0);
  const [slots, setSlots] = useState([]);
const [selectedDate, setSelectedDate] = useState("");
const [selectedTime, setSelectedTime] = useState("");
const [appointments, setAppointments] = useState([]);






const getStoredMember = () => {
  const raw = localStorage.getItem("member");

  try {
    if (!raw || raw === "undefined") return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};


const handleLogout = () => {
  localStorage.removeItem("admin");
  localStorage.removeItem("member");
  navigate("/");
};


const loadMessages = async () => {
  try {
    const user = getStoredMember();;
    if (!user) return;

    const res = await axios.get(
      `/api/getMessages.php?member_id=${user.id}&role=member`
    );

    setMessages(res.data.messages || []);
  setUnread(res.data.unread || 0);
    
  } catch (err) {
    console.error(err);
  }
};


const loadAppointments = async () => {
  const user = getStoredMember();;
  if (!user) return;

  try {
    const res = await axios.get(
      `/api/getMemberAppointments.php?member_id=${user.id}`
    );

    setAppointments(Array.isArray(res.data) ? res.data : []);
  } catch (err) {
    console.error("LOAD APPOINTMENTS ERROR:", err);
  }
};

const fetchSlots = async (date) => {
  try {
    const res = await axios.get(
      `/api/getAvailableSlots.php?date=${date}`
    );

    setSlots(Array.isArray(res.data) ? res.data : []);
  } catch (err) {
    console.error("SLOTS ERROR:", err);
  }
};

const bookAppointment = async () => {
  console.log("🔥 BUTTON CLICKED");

  if (!selectedDate) {
    alert("DATE MISSING");
    return;
  }

  if (!selectedTime) {
    alert("TIME MISSING");
    return;
  }

  try {
    const res = await axios.post(
      "/api/bookAppointment.php",
      {
        member_id: member.id,
        date: selectedDate,
        time: selectedTime,
      }
    );

    console.log("BOOK RESPONSE:", res.data);

    if (res.data.error) {
      alert(res.data.error);
      return;
    }

    alert("✅ Rendez-vous confirmé");

    fetchSlots(selectedDate);
    loadAppointments();

  } catch (err) {
    console.error("BOOK ERROR:", err);
    alert("Erreur serveur");
  }
};




// =========================
  // 🔄 LOAD ALL DATA
  // =========================
  useEffect(() => {
    const user = getStoredMember();;

    if (!user) {
      navigate("/member-login");
      return;
    }

    const loadData = async () => {
      try {
        const [memberRes, docsRes, msgRes] = await Promise.all([
          axios.get(`/api/getMember.php?id=${user.id}`),
          axios.get(`/api/getDocuments.php?member_id=${user.id}`),
          axios.get(`/api/getMessages.php?member_id=${user.id}&role=member`)
        ]);

        setMember(memberRes.data.member);
        setDocuments(docsRes.data || []);
        setMessages(msgRes.data.messages || []);
      setUnread(msgRes.data.unread || 0);
      } catch (err) {
        console.error("LOAD ERROR:", err);
      }

      setLoading(false);
    };

    loadData();
loadAppointments();
console.log("SLOTS:", slots);
   
  }, [navigate]);


const openChat = async () => {
  setShowChat(true);

  try {
 await axios.post(
  "/api/markAsRead.php",
  { member_id: member.id }, // 🔥 FIX
  { withCredentials: true }
);
    setUnread(0); // 🔥 reset badge instantly
    loadMessages();
  } catch (err) {
    console.error(err);
  }
};




useEffect(() => {
  loadMessages(); // initial load

  const interval = setInterval(() => {
    loadMessages();
  }, 5000);

  return () => clearInterval(interval);
}, []);

useEffect(() => {
  chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
}, [messages]);

  // =========================
  // 💬 SEND MESSAGE
  // =========================
  const sendMessage = async () => {
    if (!newMessage.trim()) return;

    setSending(true);

    try {
await axios.post(
  "/api/sendMessage.php",
  {
    member_id: member.id,  // 🔥 ADD THIS
    message: newMessage
  },
  { withCredentials: true }
);

      setNewMessage("");

      

      const res = await axios.get(
        `/api/getMessages.php?member_id=${member.id}`
      );

      setMessages(res.data.messages || []); 
    } catch (err) {
      console.error("SEND ERROR:", err);
      alert("Erreur envoi message");
    }

    setSending(false);
  };

  // =========================
  // 🚪 LOGOUT
  // =========================
  const logout = () => {
    localStorage.removeItem("member");
    navigate("/login");
  };

  // =========================
  // ⏳ STATES
  // =========================
  if (loading) return <p style={{ padding: 20 }}>Chargement...</p>;
  if (!member) return <p style={{ padding: 20 }}>Aucune donnée</p>;

  // STATUS
  const today = new Date();
  const exp = new Date(member.dateExpiration);
  const isExpired = exp < today;

  // =========================
  // 🎨 UI
  // =========================
 return (
  <div className="portal-page">
     <button onClick={handleLogout} className="logout-btn">
   Logout
</button>

    {/* 🔝 HEADER */}
    <div className="portal-topbar">
      <div className="user-info">
        <span className="user-icon">👤</span>
        <h2>{member.prenom} {member.nom}</h2>
      </div>

    
    </div>

    {/* 🧑 PROFILE HERO */}
    <div className="profile-hero">
      <div className="avatar">
        {member.prenom?.[0]}
        {member.nom?.[0]}
      </div>

      <div>
        <h3>{member.prenom} {member.nom}</h3>
        <span className={`badge ${isExpired ? "expired" : "active"}`}>
          {isExpired ? "Expiré" : "Actif"}
        </span>
      </div>
    </div>

    {/* 📊 GRID */}
    <div className="dashboard-grid">

      {/* LEFT SIDE */}
      <div className="left-col">

        {/* INFO */}
        <div className="card info-grid">
          <Info label="Email" value={member.email} />
          <Info label="Numéro membre" value={member.numero_membre} />
          <Info label="Téléphone" value={member.contact} />
          <Info label="Adresse" value={member.adresse} />
          <Info label="Adhésion" value={member.adhesion} />
          <Info label="Expiration" value={member.dateExpiration} />
        </div>

        {/* DOCUMENTS */}
        <div className="card">
          <h3>📄 Mes documents</h3>

          {documents.length === 0 ? (
            <p className="empty">Aucun document</p>
          ) : (
            <div className="doc-list">
             {documents.map((doc) => {
  const displayName = doc.original_name || doc.file_name;

  return (
    <a
      key={doc.id}
      href={`/api/image.php?file=${doc.file_name}`}
      target="_blank"
      rel="noreferrer"
      className="doc-item"
    >
      📄 {displayName}
    </a>
  );
})}
            </div>
          )}
        </div>

      </div>

      {/* RIGHT SIDE */}
      <div className="right-col">

        {/* BOOKING */}
        <div className="card">
          <h3>📅 Rendez-vous</h3>

          <input
            type="date"
            value={selectedDate}
            onChange={(e) => {
              setSelectedDate(e.target.value);
              fetchSlots(e.target.value);
            }}
          />

       <div className="slots">
  {slots.map((s) => {
    const isBlocked = s.blocked;
    const isFull = !s.available;
    const isSelected = selectedTime === s.time;

    return (
      <button
        key={s.time}
        disabled={isFull || isBlocked} // ✅ critical
        className={`slot-btn 
          ${isSelected ? "active" : ""} 
          ${isFull ? "full" : ""} 
          ${isBlocked ? "blocked" : ""}
        `}
        onClick={() => {
          if (!isFull && !isBlocked) {
            setSelectedTime(s.time);
          }
        }}
      >
        {s.time}

        <span className="slot-count">
          {s.count}/3
        </span>

        {/* 🚫 show blocked visually */}
        {isBlocked && <span className="blocked-label">🚫</span>}
      </button>
    );
  })}
</div>



          <button className="btn primary" onClick={bookAppointment}>
            ✅ Confirmer
          </button>
        </div>

        {/* MY APPOINTMENTS */}
        <div className="card">
          <h3>📋 Mes rendez-vous</h3>

          {appointments.length === 0 ? (
            <p>Aucun rendez-vous</p>
          ) : (
            appointments.map((a) => (
              <div key={a.id} className="appointment-item">
  <div className="appointment-date">
    {a.date}
  </div>

  <div className="appointment-time">
    {a.time}
  </div>

  <button
    className="cancel-btn"
    onClick={async () => {
      await axios.post(
        "/api/cancelAppointment.php",
        { id: a.id }
      );
      loadAppointments();
    }}
  >
    Annuler
  </button>
</div>
            ))
          )}
        </div>

      </div>
    </div>

    {/* 💬 FLOATING CHAT BUTTON */}
    <button onClick={openChat} className="chat-fab">
      💬
      {unread > 0 && <span className="badge">{unread}</span>}
    </button>

    {/* 💬 CHAT MODAL (UNCHANGED) */}
    {showChat && (
      <div className="modal-overlay">
        <div className="modal">

          <div className="modal-header">
            <h3>💬 Messages</h3>
            <button onClick={() => setShowChat(false)}>✖</button>
          </div>

          <div className="chat-box">
  {messages.map((msg) => {
    const role = msg.sender?.toLowerCase();

    return (
      <div
        key={msg.id}
        className={`message ${role === "admin" ? "admin" : "member"}`}
      >
        {msg.message}

        {role === "admin" && (
          <span className="ticks">
            {msg.is_read ? "✔✔" : "✔"}
          </span>
        )}
      </div>
    );
  })}

  <div ref={chatEndRef} />
</div>

          <div className="chat-input">
            <input
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              placeholder="Écrire un message..."
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />
            <button onClick={sendMessage}>
              {sending ? "..." : "Envoyer"}
            </button>
          </div>

        </div>
      </div>
    )}

  </div>
);
}

// =========================
// 🧩 COMPONENT
// =========================
const Info = ({ label, value }) => (
  <div className="info-box">
    <span className="label">{label}</span>
    <span className="value">{value || "-"}</span>
  </div>




);

export default MemberPortal;